<template>
  <div class="min-h-screen bg-gray-50 flex flex-col justify-between">
    <div>
      <Nav />

      <!-- Top filter bar -->
      <div class="max-w-screen-xl mx-auto px-4 mt-4">
        <div class="flex flex-wrap gap-2 justify-between border-b pb-3">
          <div class="border border-gray-300 rounded-md px-3 py-1 bg-white hover:bg-gray-100 cursor-pointer text-sm font-medium">Free Pickup</div>
          <div class="border border-gray-300 rounded-md px-3 py-1 bg-white hover:bg-gray-100 cursor-pointer text-sm font-medium">All Discounts</div>
          <div class="border border-gray-300 rounded-md px-3 py-1 bg-white hover:bg-gray-100 cursor-pointer text-sm font-medium">Under $25</div>
          <div class="border border-gray-300 rounded-md px-3 py-1 bg-white hover:bg-gray-100 cursor-pointer text-sm font-medium">Filters</div>
        </div>
        <p class="text-xs text-gray-500 mt-2 font-semibold">Price and other details may vary based on product size and color</p>
      </div>

      <!-- Main Dress Listings -->
      <div class="max-w-screen-xl mx-auto px-4 mt-6">
        <div class="grid grid-cols-1 gap-6">
          <div v-for="dress in redDress" :key="dress.id" class="bg-white border border-gray-200 rounded-lg p-4 shadow-sm flex flex-col sm:flex-row gap-6 hover:shadow-md transition-shadow">

            <!-- Left Side: Product Image -->
            <div class="w-full sm:w-48 md:w-56 lg:w-64 flex-shrink-0 flex items-center justify-center">
              <img
                v-if="getPhoto(dress)"
                :src="getPhoto(dress)"
                alt="Product image"
                class="w-full h-64 sm:h-48 md:h-56 lg:h-64 object-cover rounded-md"
              />
            </div>

            <!-- Right Side: Details -->
            <div class="flex-1 flex flex-col justify-between">
              <div>
                <!-- Brand/Title or Category Info -->
                <div class="text-sm font-bold text-gray-500 uppercase tracking-wider mb-1">Dress Premium Edition</div>

                <!-- Description -->
                <h2 class="text-base md:text-lg font-semibold text-gray-800 mb-2">
                  {{ getAttrValue(dress, 'Description') || 'Premium designer product' }}
                </h2>

                <!-- Attributes Grid -->
                <div class="grid grid-cols-2 gap-2 text-sm text-gray-600 mb-4 bg-gray-50 p-3 rounded-md border border-gray-100">
                  <div v-if="getAttrValue(dress, 'Size')">
                    <span class="font-bold text-gray-700">Size:</span> {{ getAttrValue(dress, 'Size') }}
                  </div>
                  <div v-if="getAttrValue(dress, 'Color')">
                    <span class="font-bold text-gray-700">Color:</span> {{ getAttrValue(dress, 'Color') }}
                  </div>
                  <div v-if="getAttrValue(dress, 'Price')">
                    <span class="font-bold text-gray-700">Price:</span> <span class="text-green-600 font-bold text-base">${{ getAttrValue(dress, 'Price') }}</span>
                  </div>
                  <div v-if="getAttrValue(dress, 'Sex')">
                    <span class="font-bold text-gray-700">Gender:</span> {{ getAttrValue(dress, 'Sex') }}
                  </div>
                </div>
              </div>

              <!-- Ratings / Sales Info -->
              <div class="border-t border-gray-100 pt-4 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                <div>
                  <div class="text-sm font-bold text-yellow-600">#1 Top Rated</div>
                  <div class="text-xs text-gray-400 font-semibold">100k+ bought in past month</div>
                </div>
                <div class="flex items-center gap-2">
                  <select class="border border-gray-200 rounded-lg px-2 py-1 text-xs bg-gray-50 focus:outline-none">
                    <option>Qty: 1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                  </select>
                  <button class="bg-yellow-400 hover:bg-yellow-500 transition-colors text-gray-900 font-bold text-xs px-5 py-2 rounded-full shadow-sm">
                    Add to Cart
                  </button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="mt-12">
      <div class="bg-gray-600 text-white text-center py-3 cursor-pointer hover:bg-gray-500 transition-colors">
        <div class="text-xs"><i class="fa-solid fa-caret-up"></i></div>
        <div class="text-sm font-semibold">TOP OF PAGE</div>
      </div>

      <div class="bg-gray-800 text-white py-8 px-5">
        <div class="max-w-screen-xl mx-auto grid grid-cols-2 sm:grid-cols-3 gap-8">
          <div>
            <h3 class="font-bold mb-3 text-gray-300">Get to Know Us</h3>
            <ul class="space-y-2 text-sm text-gray-400">
              <li><a href="" class="hover:underline">Amazon.com</a></li>
              <li><a href="" class="hover:underline">Your Lists</a></li>
              <li><a href="" class="hover:underline">Registry & Gift List</a></li>
              <li><a href="" class="hover:underline">Your Account</a></li>
              <li><a href="" class="hover:underline">Sell Products on Amazon</a></li>
              <li><a href="" class="hover:underline">Recalls and Product Safety</a></li>
              <li><a href="" class="hover:underline">Customer Service</a></li>
            </ul>
          </div>
          <div>
            <h3 class="font-bold mb-3 text-gray-300">Manage</h3>
            <ul class="space-y-2 text-sm text-gray-400">
              <li><a href="" class="hover:underline">Your Orders</a></li>
              <li><a href="" class="hover:underline">Gift Cards</a></li>
              <li><a href="" class="hover:underline">Find a Gift</a></li>
              <li><a href="" class="hover:underline">Browsing History</a></li>
              <li><a href="" class="hover:underline">Your Returns</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div class="bg-gray-900 text-white py-10">
        <div class="max-w-screen-xl mx-auto px-5 text-center">
          <div class="flex justify-center flex-wrap gap-6 text-sm mb-8">
            <span class="cursor-pointer hover:underline"><i class="fa-solid fa-globe mr-1"></i> English</span>
            <span class="cursor-pointer hover:underline">$ USD - US. Dollar</span>
            <span class="flex items-center gap-1 cursor-pointer hover:underline">
              <img src="/united.jpg" alt="" class="w-6 h-4 object-cover" /> United States
            </span>
          </div>

          <div class="text-xs text-gray-400 space-y-4">
            <div class="flex justify-center flex-wrap gap-4">
              <a href="" class="hover:underline">Conditions of Use</a>
              <a href="" class="hover:underline">Privacy Notice</a>
              <a href="" class="hover:underline">Consumer Health Data Privacy Disclosure</a>
            </div>
            <div>
              Your Ads Privacy Choices <input type="checkbox" class="mt-2 ml-2" />
            </div>
            <div class="text-gray-500">
              &copy;1996-2026, Amazon.com, Inc. or its affiliates
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import axios from 'axios';
import { useRouter } from 'vue-router';
import { useEcommerceStore } from '@/stores/Ecommerce';

export default {
  components:{
    Nav
  },
  data(){
    return{
      redDress:[],
    }
  },
  mounted(){
    const EcommerceStore = useEcommerceStore()
    const router = useRouter();
    EcommerceStore.verifyLogin(router)
    this.fetchRedDress()
  },
  methods:{
    async fetchRedDress(){
      const response = await axios.get('https://ecommerce-api.kalkidan.net/api/fetchBlueDress')
      this.redDress = response.data.item
    },
    getPhoto(dress) {
      if (!dress || !dress.value) return '';
      const photoVal = dress.value.find(v => v.attribute && v.attribute.name === 'photo');
      return photoVal ? `https://ecommerce-api.kalkidan.net/${photoVal.value}` : '';
    },
    getAttrValue(dress, attrName) {
      if (!dress || !dress.value) return '';
      const attr = dress.value.find(v => v.attribute && v.attribute.name === attrName);
      return attr ? attr.value : '';
    }
  }
}
</script>

<style scoped>
</style>
